module.exports = __webpack_public_path__ + "img/pipe_with_oil_valve.f8cb3659.svg";